export default __webpack_public_path__ + "static/media/Aaron-Goodin.16ca5397.jpg";